(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-simulator"] && !Shopify.designMode) return;
  try {
    /* LAB77 02/10: aberto por padrão, lembra o CEP (localStorage) e recalcula sozinho a cada
   atualização da gaveta. Eventos por delegação: a gaveta é re-renderizada pelo tema a cada
   mudança no carrinho e os listeners presos ao formulário antigo se perdiam. */
(function () {
  if (window.__lab77Frete) return; window.__lab77Frete = true;
  var CHAVE = 'lab77_cep';
  var ufPorCep = {};
  function guardado() { try { return localStorage.getItem(CHAVE) || ''; } catch (e) { return ''; } }
  function guardar(c) { try { localStorage.setItem(CHAVE, c); } catch (e) {} }
  function mascara(d) { return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }
  function el(wrap, id) { return wrap.querySelector('#' + id); }
  function status(wrap, txt, erro) { var s = el(wrap, 'cart-shipping-status'); s.textContent = txt; s.className = 'cart-shipping__status' + (erro ? ' cart-shipping__status--error' : ''); }
  function preco(v) { try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL' }).format(parseFloat(v)); } catch (e) { return v; } }
  function prazo(wrap, r) {
    var d = r.delivery_days;
    if (d && d.length >= 2 && d[1] > 0) return (d[0] === d[1] ? d[1] : d[0] + '–' + d[1]) + ' ' + wrap.dataset.i18nDays;
    return '';
  }
  function mostrar(wrap, rates) {
    var ul = el(wrap, 'cart-shipping-results'); ul.innerHTML = '';
    if (!rates || !rates.length) { status(wrap, wrap.dataset.i18nNoRates, false); ul.hidden = true; return; }
    status(wrap, '', false);
    rates.forEach(function (r) {
      var gratis = parseFloat(r.price) === 0;
      var li = document.createElement('li'); li.className = 'cart-shipping__rate';
      var n = document.createElement('span'); n.className = 'cart-shipping__rate-name';
      var t = document.createElement('span'); t.textContent = r.name; n.appendChild(t);
      var p = prazo(wrap, r); if (p) { var sm = document.createElement('small'); sm.className = 'cart-shipping__rate-days'; sm.textContent = p; n.appendChild(sm); }
      var v = document.createElement('span'); v.className = 'cart-shipping__rate-price' + (gratis ? ' cart-shipping__rate-price--free' : ''); v.textContent = gratis ? wrap.dataset.i18nFree : preco(r.price);
      li.appendChild(n); li.appendChild(v); ul.appendChild(li);
    });
    ul.hidden = false;
  }
  function uf(cep) {
    if (ufPorCep[cep] !== undefined) return Promise.resolve(ufPorCep[cep]);
    return fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); })
      .then(function (j) { ufPorCep[cep] = j.uf || ''; return ufPorCep[cep]; }).catch(function () { return ''; });
  }
  function calcular(wrap, cep) {
    var btn = el(wrap, 'cart-shipping-btn'); if (btn) btn.disabled = true;
    status(wrap, wrap.dataset.i18nLoading, false);
    uf(cep).then(function (u) {
      var q = new URLSearchParams({ 'shipping_address[zip]': mascara(cep), 'shipping_address[country]': wrap.dataset.country || 'BR' });
      if (u) q.set('shipping_address[province]', u);
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/shipping_rates.json?' + q).then(function (r) { return r.json(); });
    }).then(function (j) { mostrar(wrap, j.shipping_rates); })
      .catch(function () { status(wrap, wrap.dataset.i18nError, true); })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'cart-shipping-zip') return;
    var d = e.target.value.replace(/\D/g, '').slice(0, 8); e.target.value = mascara(d);
  });
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'cart-shipping-form') return;
    e.preventDefault();
    var wrap = e.target.closest('.cart-shipping__details');
    var d = el(wrap, 'cart-shipping-zip').value.replace(/\D/g, '');
    if (d.length !== 8) { status(wrap, wrap.dataset.i18nError, true); return; }
    guardar(d); calcular(wrap, d);
  });
  function preparar() {
    var cep = guardado();
    document.querySelectorAll('.cart-shipping__details').forEach(function (wrap) {
      if (wrap.dataset.lab77Pronto) return; wrap.dataset.lab77Pronto = '1';
      if (cep.length === 8) { el(wrap, 'cart-shipping-zip').value = mascara(cep); calcular(wrap, cep); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparar); else preparar();
  new MutationObserver(function () { preparar(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
